<template>
    <div>
        <div class="modal fade" id="worldClocksModal" tabindex="-1" role=""
             aria-labelledby="worldClocksModalLabel" aria-hidden="true"
             @keydown.esc="closeModal">
            <div class="modal-dialog " role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="worldClocksModalLabel">{{ trans('messages.World Clocks') }}</h5>
                        <button type="button" class="close" @click="closeModal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-3 p-2">
                                <world-clock></world-clock>
                            </div>
                            <div v-for="(worldClock,index) in worldClocks" class="col-sm-3 p-2" :key="index">
                                <world-clock :timezone="worldClock.timezone" :timezone-label="worldClock.label"></world-clock>
                                <i @click="removeUserWorldClock(worldClock.id)" data-toggle="tooltip" data-placement="top" title="Remove World Clock" class="fas fa-minus ml-2 pointer remove-world-clock"></i>
                            </div>

                        </div>
                        <div class="row mt-4">
                            <div class="col-12 form-group d-flex add-world-clock">
                                <select class="form-control" v-model="timezoneIndex">
                                    <option value="-1" disabled selected>{{ trans('messages.Select timezone to add') }}</option>
                                    <option v-for="(timezoneItem,index) in timezones" :key="'tz' + index" :value="index">{{timezoneItem.name}}</option>
                                </select>
                                <i @click="addUserWorldClock()" data-toggle="tooltip" data-placement="top" title="Add New World Clock" class="fas fa-plus ml-2 pointer"></i>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import WorldClock from "./WorldClock";
import timezones from './timezone.json';

export default {
    name: "WorldClocksModal",
    components: {WorldClock},
    mounted() {
        $('#worldClocksModal').modal({backdrop: 'static', keyboard: false}).modal('show')
    },
    created() {
        this.getUserWorldClocks()
        this.timezones = timezones;
    },
    methods: {
        closeModal: function () {
            this.$emit('modal-closed',)
            $('#worldClocksModal').modal('hide');
        },
        getUserWorldClocks() {
            let $end = '/api/get-user-world-clocks/';
            let self = this;
            axios.get($end).then(function (response) {
                response = response.data;
                self.worldClocks = [];
                // console.log(response.data);
                response.data.forEach(function (worldClock) {
                    let data = {
                        id: worldClock.id,
                        timezone: worldClock.timezone,
                        label: worldClock.label
                    };
                    self.worldClocks.push(data);
                })
            }).catch(err => {
                console.log(err);
                this.$data.loader = false;
            });
        },
        addUserWorldClock() {
            if (this.timezoneIndex === -1) {
                return
            }
            this.$swal.fire({
                title: trans.messages["Add new world clock?"],
                icon: 'question',
                html: trans.messages["for"] + " " + timezones[this.timezoneIndex].name,
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: window.trans.messages.Yes,
                cancelButtonText: window.trans.messages.No,
                reverseButtons: true,
                focusConfirm: false,
                customClass: {
                    container: 'swal-over-bs-modal'
                },
            }).then((result) => {
                if(result.value) {
                    let $end = '/api/world-clock';
                    let self = this;

                    axios.post($end, {
                        timezone: timezones[this.timezoneIndex],
                    }).then(response  => {
                        self.timezoneIndex = -1;
                        this.getUserWorldClocks();
                    }).catch(err => {
                        this.$data.loader = false;
                    });
                }
            })
        },
        removeUserWorldClock(id) {
            if (!id) {
                return
            }
            let worldClock = this.worldClocks.filter((clock) => clock.id === id)[0];
            this.$swal.fire({
                title: trans.messages["Remove world clock?"],
                icon: 'warning',
                html: trans.messages["for"] + " " + (worldClock.label ? worldClock.label : worldClock.timezone),
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: trans.messages["Yes"],
                cancelButtonText: trans.messages["No"],
                reverseButtons: true,
                focusConfirm: false,
                customClass: {
                    container: 'swal-over-bs-modal'
                },
            }).then((result) => {
                if(result.value) {
                    let $end = '/api/world-clock/'+id;
                    let self = this

                    axios.delete($end).then(response  => {
                        self.timezone = ""
                        this.getUserWorldClocks();
                    }).catch(err => {
                        this.$data.loader = false;
                    });
                }
            })

        }
    },
    data: () => ({
        worldClocks: [],
        timezoneIndex: -1,
        timezones,
    }),
}
</script>

<style scoped>
.add-world-clock {
    align-items: center;
}
.remove-world-clock {
    position: absolute;
    top: 0;
    right: 5px;
}


</style>
